module.exports = __webpack_public_path__ + "img/prototypes.2d8b3b6f.jpg";